// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Save----index-module---root---3aT2U","saveIcon":"src-components-Save----index-module---saveIcon---2NkZ4","saveIconActive":"src-components-Save----index-module---saveIconActive---3M0Zv src-components-Save----index-module---saveIcon---2NkZ4","text":"src-components-Save----index-module---text---i2dob","textLarge":"src-components-Save----index-module---textLarge---3IzPc src-components-Save----index-module---text---i2dob"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Save/index.module.css
// module id = 616
// module chunks = 168707334958949